/* eslint-disable @typescript-eslint/camelcase */

import { State } from "@/models"

const state: State = {
    socket: {
        isConnected: false,
        isDispatcherConnected: false,
        isSubscribed: false,
        message: "",
        $socket: null,
        reconnectError: false,
    },
    statistics_counter: null,
    isRestarting: false,
}

export default state
